import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FilterList from './elements/FilterList/FilterList'
import { FiltersProvider } from 'clientHelpers/context/filtersContext'

import styles from './style'

const FilterGroup = ({ onSearch, filters, loading, filtersSelected }) => {
  const [filterValues, updateFilters] = useState({
    roles: null,
    locations: null,
    skills: null,
  })

  const setFilterValues = React.useCallback(
    newFilters => {
      updateFilters({
        ...filterValues,
        ...newFilters,
      })
    },
    [filterValues],
  )

  const applyFilters = filterValues => {
    setFilterValues(filterValues)
    onSearch?.(filterValues)
  }

  const hasFilterValues = () => {
    return filterValues.locations !== null || filterValues.roles !== null || filterValues.skills !== null
  }

  React.useEffect(() => {
    setFilterValues(filtersSelected)
  }, [filtersSelected])

  return (
    <FiltersProvider value={{ ...filterValues, setFilterValues, filters }}>
      <div className={`filter-container ${styles.wrapper}`}>
        <div className={styles.container}>
          <div className={styles.heading}>
            <div className={styles.desktopHeading}>
              <span className={styles.hyperlinkText}>{process.env.NEXT_PUBLIC_CANDIDATES_TREND_COUNT}</span> developers joined OfferZen in
              the last 3 months. What are you looking for?
            </div>
            <div className={styles.mobileHeading}>What are you looking for?</div>
          </div>

          <FilterList hasFilterValues={hasFilterValues} applyFilters={applyFilters} loading={loading} />
        </div>
      </div>
    </FiltersProvider>
  )
}

FilterGroup.propTypes = {
  filters: PropTypes.object,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
  filtersSelected: PropTypes.object,
}

export default FilterGroup
